import instance  from './axios'

// 获取消息动态列表
export const messageGetList=(para)=>{
  return instance.post('/message/getList',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 获取数据统计
export const getDataCount=(para)=>{
  return instance.post('/getDataCount',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//预警提示列表
export const getWarnList = (para) => {
  return instance.get('/message/getWarnList', {params: para})
}
// 预警提示
export const messageReadWarn=(para)=>{
  return instance.post('/message/readWarn',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//获取公司成员
export const accountList = (para) => {
  return instance.get('/company/account/list', {params: para})
}
export const get_qiniu_token=(para)=>{
  return instance.get('/louguanjia-web/common/get_qiniu_token',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}

// 新增/修改支出费用信息
export const saveOrUpdateCost=(para)=>{
  return instance.post('/account/saveOrUpdateCost',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 获取支出列表
export const getCostList=(para)=>{
  return instance.get('/account/getCostList',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 获取支出信息
export const getCostInfo=(para)=>{
  return instance.get('/account/getCostInfo',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//  编辑总费用信息
export const updateTotalAmount=(para)=>{
  return instance.post('/account/updateTotalAmount',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 三年租金列表
export const getRentalPlanList=(para)=>{
  return instance.get('/asset/getRentalPlanList',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 获取三年租金总计
export const getRentalTotal=(para)=>{
  return instance.get('/asset/getRentalTotal',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
// 导出三年租金列表
export const downRentalPlanList=(para)=>{
  return instance.get('/asset/downRentalPlanList',{params:para,responseType:'arraybuffer'},{
    headers:{
      'Content-Type': 'application/vnd.ms-excel',
    }
  })
}